import {Card, Container, Group, Menu, rem, Stack, Text, Title, UnstyledButton} from "@mantine/core";
import {useMemo, useState} from "react";
import {routesSelector, useGetAllRoutesQuery} from "@ots-frontend/ots-data";
import {IconChevronDown} from "@tabler/icons-react";
import {useTranslation} from "react-i18next";
import {skipToken} from "@reduxjs/toolkit/query";
import {PAGINATION_PAGE_SIZES} from "../../components/data-table/DataTable/usePagination";
import {RouteDataTable} from "../../components/data-table/RouteDataTable/RouteDataTable";
import {ResizeableContent} from "../../components/ResizableContent/ResizableContent";
import {ThemedPage} from "../../components/page/ThemedPage/ThemedPage";
import {useApp} from "../../providers/RegionProvider/RegionProvider";
import {ProtectedPage} from "../../components/page/ProtectedPage/ProtectedPage";

export type RouteDataTablePageProps = {}

export const RouteDataTablePage = (props: RouteDataTablePageProps) => {

  const {t} = useTranslation(["translation", "common"]);
  const {regionId} = useApp();

  const [access, setAccess] = useState(false);

  const selectRoutes = useMemo(() => {
    return routesSelector()
  }, []);

  const {routes, isLoading, error, refetch} = useGetAllRoutesQuery(access ? (regionId ?? skipToken) : skipToken, {
    selectFromResult: (result) => ({
      ...result,
      routes: selectRoutes(result, {regionId}),
      isLoading: result.isLoading,
      error: result.error,
    })
  });

  return (
    <ProtectedPage permissions={["route_view"]} isLoading={isLoading} error={error} onAccess={setAccess}>
      {(classes) => (
        <ResizeableContent>
          {(size) => (
            <Container h={size.height} w={size.width} className={classes.container} fluid={true} p="md">
              <Stack h="100%" m="sm">
                <Card shadow="sm" padding="lg" mb="lg" radius="md" withBorder>
                  <Group position="apart">
                    <Title
                      order={4}>{t("page.route.title", "Routes", {ns: "translation"})}</Title>
                    <Menu
                      width={260}
                      position="bottom-end"
                      transitionProps={{transition: "pop-top-right"}}
                      withinPortal
                    >
                      <Menu.Target>
                        <UnstyledButton>
                          <Group spacing={7}>
                            <Text weight={500} size="sm" sx={{lineHeight: 1}} mr={3}>
                              Actions
                            </Text>
                            <IconChevronDown size={rem(12)} stroke={1.5}/>
                          </Group>
                        </UnstyledButton>
                      </Menu.Target>
                      <Menu.Dropdown>
                        <Menu.Item onClick={() => refetch()}>
                          {t("actions.refresh", "Refresh", {ns: "common"})}
                        </Menu.Item>
                      </Menu.Dropdown>
                    </Menu>
                  </Group>
                </Card>
                <RouteDataTable
                  withBorder
                  records={routes}
                  recordsPerPageOptions={PAGINATION_PAGE_SIZES}
                  fetching={isLoading}/>
              </Stack>
            </Container>
          )}
        </ResizeableContent>
      )}
    </ProtectedPage>
  );
};
